import { Divider, Grid, Typography } from '@mui/material';
import React from 'react'
import mappingStyles from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import globalStyles from "../../../../assets/styles/global.module.scss"; 
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import { EcomProduct } from '../../../../models/axiosModel';

interface ProductAdditionalInfoPopupProps {
    selectedProduct: EcomProduct,
}

const ProductAdditionalInfoPopup: React.FC<ProductAdditionalInfoPopupProps> = (props) => {

    const { selectedProduct } = props;

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={mappingStyles.popupTitleTypography}>{`Additional Information Of ${selectedProduct?.ecom_product_name}`}</Typography>
                        </Grid>

                        <Divider className={mappingStyles.popupTitleDivider} /> 

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={mappingStyles.popupBodyGridContainer} gap={1}>
                                {selectedProduct?.ecom_additional_fields_json ?
                                    <Grid item xs={12}>
                                        <Grid item xs={12} className={globalStyles.relativePosition}>
                                            <pre className={`${styles.threadExecutionTimeLogPreTag}`}>
                                                {JSON.stringify(JSON.parse(selectedProduct?.ecom_additional_fields_json), null, 4)}
                                            </pre>
                                        </Grid>
                                    </Grid>
                                    : 
                                    <Grid item xs={12}> 
                                        <Typography className={mappingStyles.popupFieldTypography}>No Additional Info Available</Typography>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProductAdditionalInfoPopup
